import { get, post, postFormData } from 'service/xhr/fetch'
import { URL_PREFIX } from 'utils/constant'

export const GET_POLICY_TEMPLATE_PAGE_LIST = (data: any) => {
  return get(`/${URL_PREFIX}/policy-template/page-list`, data)
}

export const GET_POLICY_TEMPLATE_INFO = (id: string) => {
  return get(`/${URL_PREFIX}/policy-template/getInfo`, { id })
}

export const ADD_POLICY_TEMPLATE = (data: any) => {
  return post(`/${URL_PREFIX}/policy-template/input`, data)
}

export const UPDATE_POLICY_TEMPLATE = (data: any) => {
  return post(`/${URL_PREFIX}/policy-template/update`, data)
}

export const DEL_POLICY_TEMPLATE = (id: string) => {
  return postFormData(`/${URL_PREFIX}/policy-template/del`, { id })
}
